export default __webpack_public_path__ + "static/017-3d752836e38c34d8664e65828ad2eafd.jpg";